// Defaults match "AI OPS PORTAL" app registration — override via REACT_APP_AZURE_* env vars
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '01886139-2f5a-465d-8db0-cc2046e078ab';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '7c7fea3f-e205-448e-b10a-701c54916e39';

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId || 'organizations'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
